module.exports = __webpack_public_path__ + "img/story049.05aff256.webp";